import { SelectionModel } from '@angular/cdk/collections';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DisplayMode, SelectBox, TimeApiService } from 'cbc-shared-lib';
import { Subject } from 'rxjs';
import { CodeConversionMstDto, Sgke382aResponseSearchResultList } from 'sg-api';
import { CodeConversionMstService } from '../../../../../../sg-base/sg-base-shared/services/codeConversionMst.service';
import { ListSearchUtils } from '../../../../../sg-ke-shared/util/list-search-utils';

@Component({
  selector: 'app-sgke380d-search-result',
  templateUrl: './sgke380d-search-result.component.html',
  styleUrl: './sgke380d-search-result.component.scss'
})
export class Sgke380dSearchResultComponent implements OnInit, OnDestroy {
  /** 画面モード（サービサー委託対象検索画面/サービサー返却検索画面） */
  @Input() task: string;

  /** 検索結果データ */
  @Input() responseList: Array<Sgke382aResponseSearchResultList>;

  /** コードマスタ取得 */
  @Input() codeConversionMstMap: Map<string, Array<CodeConversionMstDto>> = null;

  /** 明細行クリックイベント */
  @Output() onClickBillingPortalEvent = new EventEmitter<Sgke382aResponseSearchResultList>();

  /** 登録ボタン押下イベント */
  @Output() onClickTargetRegistEvent = new EventEmitter<Sgke382aResponseSearchResultList[]>();

  /** 移転先調査要否登録ボタン押下イベント */
  @Output() onClickRelocationResearchResistEvent = new EventEmitter<Sgke382aResponseSearchResultList[]>();

  /** 再委託登録ボタン押下イベント */
  @Output() onClickRecnsgnResistEvent = new EventEmitter<Sgke382aResponseSearchResultList[]>();

  /** ソート制御 */
  @ViewChild('sort1', { static: true }) sort: MatSort;

  /** 購読を停止するためのSubject */
  private onDestroy$ = new Subject();

  /** モード区分_登録 */
  public MODE_CREATE = DisplayMode.create;
  /** モード区分_更新 */
  public MODE_UPDATE = DisplayMode.update;

  /** 検索結果表データ */
  dataSource: MatTableDataSource<Sgke382aResponseSearchResultList>;
  /** 選択行 */
  selection: SelectionModel<Sgke382aResponseSearchResultList> = new SelectionModel<Sgke382aResponseSearchResultList>(true, []);
  /** サービサー委託対象リスト(S300010) */
  servicerConsignmentTargetList: SelectBox[] = [];
  /** 委託先リスト(S300160) */
  consignmentList: SelectBox[] = [];
  /** 移転先調査要否リスト(S300030) */
  transferDestinationTyosayohiList: SelectBox[] = [];
  /** サービサー再委託対象リスト(S300110) */
  serviceRecommissionTargetList: SelectBox[] = [];
  /** 再委託対象外理由リスト(S300040) */
  recommissionTargetTargetgaiRsnList: SelectBox[] = [];

  /**
   * サービサー委託対象コード コード値定数
   */
  /** 対象 */
  S300010_ASSIGN = "0";

  /**
   * サービサー再委託可否コード コード値定数
   */
  /** 対象外 */
  S300110_NOREASSIGN = "1";

  /**
   * サービサー委託ステータス コード値定数
   */
  /** 委託対象 */
  S300000_ASSIGN = "02";
  /** 委託対象外 */
  S300000_NOASSIGN = "01";
  /** 委託保留 */
  S300000_ASSIGNHOLD = "00";
  /** 返却（可否登録待ち） */
  S300000_RETURNPENDING = "06";
  /** 再委託可 */
  S300000_REASSIGNABLE = "08";
  /** 再委託対象外 */
  S300000_NOREASSIGN = "09";

  /**
   * 画面のモードに応じて画面の最大幅を制御
   * @readonly
   * @type {string}
   * @memberof Sgke380dSearchResultComponent
   */
  get minWidth(): string {
    return this.task == this.MODE_UPDATE ? '1734px' : '1500px';
  }

  /**
   * 検索結果テーブル表示カラム
   * @readonly
   * @type {string[]}
   * @memberof Sgke380dSearchResultComponent
   */
  get displayedColumnsCol(): string[] {
    return this.task == this.MODE_UPDATE ? [
      // サービサー返却検索画面・検索結果,
      // チェックボックス
      'select',
      // 移転先調査要否コード値
      'transferdestinationTyosayohiCodevalue',
      // サービサー再委託対象コード値
      'servicerRecommissiontargetCodevalue',
      // 委託先コード値
      'consignmenttoCodevalue',
      // 再委託対象外理由コード値
      'recommissiontargetTargetgairsnCodevalue',
      // 会社コード名称
      'companyAname',
      // 督促担当地区コード名称
      'pressInchargeregionAname',
      // 督促管理区分コード名称
      'pressmanagementdivisionAname',
      // サービサー委託ステータスコード名称
      'servicerconsignmentStsAname',
      // お客さま番号
      'visitornumber',
      // 支払契約番号
      'payCtrNo',
      // 請求先名
      'visitName',
      // 委託金額
      'consignMny',
      // 未収総額
      'receivableTotalmoney',
      // ガス
      'gas',
      // 電気
      'elec',
      // メッセージ
      'message',
      // 前回委託先
      'preConsignmentto',
      // 委託開始日
      'consignStartdate',
      // 委託停止日
      'consignStpDate',
      // 委託停止理由コード名称
      'consignmentsuspensionReasonAname',
    ] : [
      // サービサー委託対象検索画面・検索結果,
      // チェックボックス
      'select',
      // サービサー委託対象コード値
      'servicerconsignmenttargetCodevalue',
      // 委託先コード値
      'consignmenttoCodevalue',
      // 会社コード名称
      'companyAname',
      // 督促担当地区コード名称
      'pressInchargeregionAname',
      // 督促管理区分コード名称
      'pressmanagementdivisionAname',
      // サービサー委託ステータスコード名称
      'servicerconsignmentStsAname',
      // お客さま番号
      'visitornumber',
      // 支払契約番号
      'payCtrNo',
      // 請求先名
      'visitName',
      // 委託予定金額
      'consignScdMny',
      // ガス
      'gas',
      // 電気
      'elec',
      // メッセージ
      'message',
      // 供給停止・解約日
      'supplystopTerminationdate',
      // 解約理由コード名称
      'breakReasonAname',
    ];
  }

  /**
   * 全行選択時の制御
   * @readonly
   * @type {*}
   * @memberof Sgke380dSearchResultComponent
   */
  get isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /**
   * コンストラクタ
   * @param {TimeApiService} timeApiService
   * @param {CodeConversionMstService} codeConvert
   * @param {ListSearchUtils} listSearchUtils
   * @memberof Sgke380dSearchResultComponent
   */
  constructor(
    public timeApiService: TimeApiService,
    private codeConvert: CodeConversionMstService,
    private listSearchUtils: ListSearchUtils,
  ) {
  }

  /**
   * 初期処理
   * @memberof Sgke380dSearchResultComponent
   */
  ngOnInit(): void {

    /** サービサー委託対象リスト(S300010) */
    this.servicerConsignmentTargetList = this.getSelectBoxFromCodeConversionMst('S300010');
    /** 委託先リスト(S300160) */
    this.consignmentList = this.getSelectBoxFromCodeConversionMst('S300161');
    /** 移転先調査要否リスト(S300030) */
    this.transferDestinationTyosayohiList = this.getSelectBoxFromCodeConversionMst('S300030');
    /** サービサー再委託対象リスト(S300110) */
    this.serviceRecommissionTargetList = this.getSelectBoxFromCodeConversionMst('S300110');
    /** 再委託対象外理由リスト(S300040) */
    this.recommissionTargetTargetgaiRsnList = this.getSelectBoxFromCodeConversionMst('S300040');

    this.responseList = this.responseList.map(row => ({
      ...row,
      servicerconsignmenttargetCodevalue: this.listSearchUtils.getListboxValue(row.servicerconsignmenttargetCodevalue, this.servicerConsignmentTargetList),
      consignmenttoCodevalue: this.listSearchUtils.getListboxValue(row.consignmenttoCodevalue, this.consignmentList),
      transferdestinationTyosayohiCodevalue: this.listSearchUtils.getListboxValue(row.transferdestinationTyosayohiCodevalue, this.transferDestinationTyosayohiList),
      servicerRecommissiontargetCodevalue: this.listSearchUtils.getListboxValue(row.servicerRecommissiontargetCodevalue, this.serviceRecommissionTargetList),
      recommissiontargetTargetgairsnCodevalue: this.listSearchUtils.getListboxValue(row.recommissiontargetTargetgairsnCodevalue, this.recommissionTargetTargetgaiRsnList) ?? null,
    }))

    this.dataSource = new MatTableDataSource<Sgke382aResponseSearchResultList>(this.responseList);

  }

  /**
   * サービスの開放
   * @memberof Sgke380dSearchResultComponent
   */
  ngOnDestroy(): void {
    this.onDestroy$.next();
  }

  /**
   * 描画後処理
   * @memberof Sgke380dSearchResultComponent
   */
  ngAfterViewChecked() {
    this.dataSource.sort ??= this.sort;
  }

  /**
   * 明細行：チェックボックスに応じた表タイトル：チェックボックス制御
   * @returns {string} 
   * @memberof Sgke380dSearchResultComponent
   */
  checkboxLabel(): string {
    return `${this.isAllSelected ? 'select' : 'deselect'} all`;
  }

  /**
   * テーブルのセル有効・活性判定
   * @param {string} column 
   * @param {Sgke382aResponseSearchResultList} row 
   * @returns {boolean}
   * @memberof Sgke380dSearchResultComponent
   */
  isEnableCell(column: string, row: Sgke382aResponseSearchResultList): boolean {
    // カラム毎それぞれの条件を記載。
    switch (column) {
      case 'recommissiontargetTargetgairsnCodevalue': // 再委託対象外理由
        // サービサー再委託対象が「対象外」のみ
        return this.S300110_NOREASSIGN == row.servicerRecommissiontargetCodevalue;
      case 'servicerRecommissiontargetCodevalue': // サービサー再委託対象
        // サービサー委託ステータスが
        // 「返却(可否登録待ち)」「再委託可」「再委託対象外」のいずれか
        return [this.S300000_RETURNPENDING, this.S300000_REASSIGNABLE, this.S300000_NOREASSIGN].includes(row.servicerconsignmentStsCodevalue);
      case 'transferdestinationTyosayohiCodevalue': // 移転先調査要否
        // サービサー委託ステータスが
        //「返却(可否登録待ち)」「再委託可」「再委託対象外」のいずれか
        return [this.S300000_RETURNPENDING, this.S300000_REASSIGNABLE, this.S300000_NOREASSIGN].includes(row.servicerconsignmentStsCodevalue);
      default:
        // 有効
        return true;
    }
  }

  /**
   * サービサー再委託対象の制御
   * @param {Sgke382aResponseSearchResultList} row
   * @memberof Sgke380dSearchResultComponent
   */
  onChangeRecnsgnJudgeList(row: Sgke382aResponseSearchResultList) {
    if (row.servicerRecommissiontargetCodevalue != this.S300110_NOREASSIGN) {
      row.recommissiontargetTargetgairsnCodevalue = undefined;
    }
  }

  /**
   * 表タイトル：チェックボックス=ONに応じた明細行：チェックボックスの制御
   * @memberof Sgke380dSearchResultComponent
   */
  onClickAllCheck(): void {
    this.dataSource.data.forEach(row => {
      this.selection.select(row);
    });
  }

  /**
   * 表タイトル：チェックボックス=OFFに応じた明細行：チェックボックスの制御
   * @memberof Sgke380dSearchResultComponent
   */
  onClickAllClear(): void {
    this.selection.clear();
  }

  /**
   * 明細行クリック時の処理
   * @param {Sgke382aResponseSearchResultList} row 対象行情報
   * @param {MouseEvent} event マウスイベント
   * @memberof Sgke380dSearchResultComponent
   */
  onDblClickRow(row: Sgke382aResponseSearchResultList, event?: MouseEvent): void {
    this.onClickBillingPortalEvent.emit(row);
    event?.stopPropagation();
  }

  /**
   * 登録ボタンの非活性制御
   * @returns {boolean}
   * @memberof Sgke380dSearchResultComponent
   */
  disableTargetResist(): boolean {
    let selected = this.selection.selected;
    return selected.length < 1 || selected.some(row => {
      return row.servicerconsignmenttargetCodevalue == '1' && row.companyAname == null;
    });
  }

  /**
   * 移転先調査要否登録ボタンの非活性制御 <br>
   * @returns {boolean}
   * @memberof Sgke380dSearchResultComponent
   */
  disableRelocationResearchResist(): boolean {
    let selected = this.selection.selected;
    return selected.length < 1
  }

  /**
   * 再委託登録ボタンの非活性制御 <br>
   * @returns {boolean}
   * @memberof Sgke380dSearchResultComponent
   */
  disableRecnsgnResist(): boolean {
    let selected = this.selection.selected;
    return selected.length < 1
  }

  /**
   * 登録ボタン押下時の処理
   * @memberof Sgke380dSearchResultComponent
   */
  onClickTargetRegist(): void {
    this.onClickTargetRegistEvent.emit(this.selection.selected);
  }

  /**
   * 移転先調査要否登録ボタン押下時の処理
   * @memberof Sgke380dSearchResultComponent
   */
  onClickRelocationResearchResist(): void {
    this.onClickRelocationResearchResistEvent.emit(this.selection.selected);
  }

  /**
   * 再委託登録ボタン押下時の処理
   * @memberof Sgke380dSearchResultComponent
   */
  onClickRecnsgnResist(): void {
    this.onClickRecnsgnResistEvent.emit(this.selection.selected);
  }

  /**
   * コードIDに対応するコード変換マスタ値をSelectBoxの配列で戻す
   * @param {string} codeId
   * @return {*}  {SelectBox[]}
   * @memberof Sgke380dSearchResultComponent
   */
  getSelectBoxFromCodeConversionMst(codeId: string): SelectBox[] {
    let retSelectBoxList: SelectBox[] = [];
    let codeList: CodeConversionMstDto[] = [];
    if (this.codeConversionMstMap.has(codeId)) {
      codeList = this.codeConversionMstMap.get(codeId);
      if (codeList) {
        codeList.forEach(data => {
          const select: SelectBox = { value: data.userCode, viewValue: data.hyojiCont };
          retSelectBoxList.push(select);
        })
      }
    }
    return retSelectBoxList;
  }

}
